import { UnitsApiService } from '@api_patient/units_api.service';
import { AnalyticService } from '@application/analytic/analytic.service';
import { UniversalConfig } from '@application/universal_config.service';
import { Flex } from '@cellula/react';
import { generatePdfViewerLink } from '@module/pdf_url_encode';
import { UnitConfigApiModel } from '@visiba/api-vcs-client-v2';
import { useService } from '@visiba/instantiation';
import { useEffect, useState } from 'react';

interface Props {
	baseUrl: string;
}

export function TermsOfService({ baseUrl }: Props): JSX.Element {
	const analyticService = useService(AnalyticService);
	const unitsApiService = useService(UnitsApiService);
	const universalConfig = useService(UniversalConfig);

	const [aboutData, setAboutData] = useState<UnitConfigApiModel>({} as UnitConfigApiModel);

	useEffect(() => {
		analyticService.trackPageView({ customTitle: 'TermsOfService' });
		unitsApiService
			.getUnitConfig(universalConfig.selectedUnitId)
			.then((data) => {
				if (data.ok) setAboutData(data.ok.data);
			})
			.catch(console.error);
	}, [analyticService, unitsApiService, universalConfig.selectedUnitId]);

	return (
		<Flex style={{ height: '100vh' }}>
			{aboutData.TermsOfServiceUrl && (
				<iframe
					title='Terms of service document'
					src={generatePdfViewerLink(baseUrl, aboutData.TermsOfServiceUrl, 'TermsOfService')}
					width='100%'
					height='100%'
					allow='fullscreen'
				></iframe>
			)}
		</Flex>
	);
}
